// icons need to be added to our custom kit first before being able to import them: https://fontawesome.com/kits/b75a5da439/icons

import {
  faAnglesUpDown,
  faBars,
  faBell,
  faBellSlash,
  faBoxCheck,
  faBuilding,
  faBullseye,
  faCamera,
  faCaretLeft,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleInfo,
  faClock,
  faCommentAlt,
  faCopy,
  faCube,
  faCubes,
  faDesktop,
  faDirections,
  faDumpster,
  faEnvelope,
  faEraser,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faFileContract,
  faFire,
  faGripLines,
  faHexagonExclamation,
  faHourglassClock,
  faIdBadge,
  faImage,
  faImages,
  faIndustry,
  faLeft,
  faLevelDown,
  faLevelUp,
  faLocationCrosshairs,
  faMagnifyingGlass,
  faMapMarkedAlt,
  faMobileAlt,
  faNote,
  faPaperPlaneTop,
  faPen,
  faReceipt,
  faRhombus,
  faRight,
  faScrewdriverWrench,
  faServer,
  faShieldExclamation,
  faSignature,
  faStar,
  faSync,
  faTrash,
  faTruck,
  faUser,
  faUserCircle,
  faWeightHanging,
  faXmark,
} from '@awesome.me/kit-b75a5da439/icons/classic/light'
import { faStar as faStarSolid } from '@awesome.me/kit-b75a5da439/icons/classic/solid'

export type IconName = keyof typeof ICONS

export const ICONS = {
  'angles-up-down': faAnglesUpDown,
  'bars': faBars,
  'bell-slash': faBellSlash,
  'bell': faBell,
  'box-check': faBoxCheck,
  'building': faBuilding,
  'bullseye': faBullseye,
  'camera': faCamera,
  'caret-left': faCaretLeft,
  'check-circle': faCheckCircle,
  'check': faCheck,
  'chevron-down': faChevronDown,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'circle-info': faCircleInfo,
  'clock': faClock,
  'close': faXmark,
  'comment-alt': faCommentAlt,
  'copy': faCopy,
  'cube': faCube,
  'cubes': faCubes,
  'desktop': faDesktop,
  'directions': faDirections,
  'dumpster': faDumpster,
  'envelope': faEnvelope,
  'eraser': faEraser,
  'exclamation-circle': faExclamationCircle,
  'exclamation-triangle': faExclamationTriangle,
  'external-link': faExternalLink,
  'eye': faEye,
  'file-contract': faFileContract,
  'fire': faFire,
  'grip-lines': faGripLines,
  'hexagon-exclamation': faHexagonExclamation,
  'hourglass-clock': faHourglassClock,
  'id-badge': faIdBadge,
  'image': faImage,
  'images': faImages,
  'industry': faIndustry,
  'left': faLeft,
  'level-down': faLevelDown,
  'level-up': faLevelUp,
  'location-crosshairs': faLocationCrosshairs,
  'magnifying-glass': faMagnifyingGlass,
  'map-marked-alt': faMapMarkedAlt,
  'mobile-alt': faMobileAlt,
  'note': faNote,
  'paper-plane-top': faPaperPlaneTop,
  'pen': faPen,
  'receipt': faReceipt,
  'refresh': faSync,
  'rhombus': faRhombus,
  'right': faRight,
  'screwdriver-wrench': faScrewdriverWrench,
  'server': faServer,
  'shield-exclamation': faShieldExclamation,
  'signature': faSignature,
  'star-solid': faStarSolid,
  'star': faStar,
  'trash': faTrash,
  'truck': faTruck,
  'user-circle': faUserCircle,
  'user': faUser,
  'weight-hanging': faWeightHanging,
}
